import { Col, Row } from 'antd'
import { AiOutlinePlusSquare, AiOutlineMinusSquare, AiOutlineCloseSquare } from 'react-icons/ai'
import { GiRoundStar } from 'react-icons/gi'

type AttributeCardProps = {
  icon: JSX.Element
  type: string
  attribute: string
  margin?: string
  stars?: boolean
  levelCap?: string
  editable?: boolean
  removable?: boolean
  editHook?(value: number): void
}

const fillStars = (current: string, cap = 5) => {
  const stars: JSX.Element[] = []
  let idx = 0

  for (idx; idx < Number(current); idx++) {
    stars.push(<GiRoundStar key={`star-${idx}`} />)
  }

  for (idx; idx < cap; idx++) {
    stars.push(<GiRoundStar key={`star-${idx}`} style={{ color: '#dcdcdc' }} />)
  }

  return stars
}

const updateAttribute = (value: string, action: 'DECREMENT' | 'INCREMENT', levelCap = '99') => {
  const v = Number(value)
  const needsUpdate =
    (action === 'DECREMENT' && v !== 0) || (action === 'INCREMENT' && v !== Number(levelCap))

  if (!needsUpdate) {
    return [false, null] as const
  }

  if (action === 'DECREMENT') {
    return [true, v - 1] as const
  }

  if (action === 'INCREMENT') {
    return [true, v + 1] as const
  }

  return [false, null] as const
}

export const AttributeCard = ({
  icon,
  type,
  attribute,
  margin,
  editable = false,
  removable = false,
  stars = true,
  editHook,
  levelCap,
}: AttributeCardProps) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: '6px',
        cursor: 'pointer',
        padding: '0 8px',
        minWidth: '160px',
        margin,
        boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px',
      }}
    >
      {icon}
      <div
        style={{ width: '1px', height: '64px', backgroundColor: 'lightgray', margin: '0 10px' }}
      />
      <Col style={{ width: '100%' }}>
        <Row align={'middle'} style={{ marginTop: editable ? '-6px' : '-10px' }}>
          <span
            style={{
              fontFamily: 'HonestMaria',
              fontSize: 28,
            }}
          >
            {type}
          </span>
        </Row>
        <Row
          justify={stars || removable ? 'space-between' : 'start'}
          align={'middle'}
          style={{ marginTop: '-8px' }}
        >
          {editable && (
            <AiOutlineMinusSquare
              size={24}
              style={{ marginRight: 4 }}
              onClick={() => {
                const values = updateAttribute(attribute, 'DECREMENT', levelCap)
                values[0] ? editHook!(values[1]) : null
              }}
            />
          )}
          <span
            style={{
              fontFamily: 'HonestMaria',
              fontSize: 26,
              color: 'darkred',
              lineHeight: '0.5',
              marginRight: 4,
              marginLeft: removable || !editable ? 0 : 4,
            }}
          >
            {stars
              ? fillStars(attribute, Number(levelCap))
              : levelCap
              ? `${attribute} / ${levelCap}`
              : attribute}
          </span>
          {editable && (
            <AiOutlinePlusSquare
              size={24}
              style={{ marginLeft: 4 }}
              onClick={() => {
                const values = updateAttribute(attribute, 'INCREMENT', levelCap)
                values[0] ? editHook!(values[1]) : null
              }}
            />
          )}
          {removable && (
            <AiOutlineCloseSquare
              size={24}
              onClick={() => {
                editHook!(0)
              }}
            />
          )}
        </Row>
      </Col>
    </div>
  )
}
